import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import type { ApiIdentityAndSubscriptionActions } from "@/generated/models/ApiIdentityAndSubscriptionActions";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "@/components/auth/Auth";
import UserFollowBtn, { UserFollowBtnSize } from "@/components/user/utils/UserFollowBtn";
const FOLLOW_STATUS_PREFETCH_MARGIN = "360px";
export default function Follower(t0) {
  const $ = _c(32);
  const {
    follower,
    showFollowButton: t1,
    mutedBackground: t2
  } = t0;
  const showFollowButton = t1 === undefined ? false : t1;
  const mutedBackground = t2 === undefined ? false : t2;
  const rowRef = useRef(null);
  const [shouldLoadFollowButton, setShouldLoadFollowButton] = useState(false);
  const {
    connectedProfile
  } = useContext(AuthContext);
  const followerHandle = follower.identity.handle;
  let t3;
  if ($[0] !== followerHandle) {
    t3 = followerHandle?.toLowerCase() ?? null;
    $[0] = followerHandle;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const normalizedFollowerHandle = t3;
  let t4;
  if ($[2] !== connectedProfile?.handle) {
    t4 = connectedProfile?.handle?.toLowerCase() ?? null;
    $[2] = connectedProfile?.handle;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const normalizedConnectedHandle = t4;
  const shouldShowFollowButton = Boolean(showFollowButton && normalizedFollowerHandle && (!normalizedConnectedHandle || normalizedFollowerHandle !== normalizedConnectedHandle));
  const backgroundClass = mutedBackground ? "tw-bg-white/[0.01]" : "";
  let t5;
  let t6;
  if ($[4] !== shouldLoadFollowButton || $[5] !== shouldShowFollowButton) {
    t5 = () => {
      if (!shouldShowFollowButton || shouldLoadFollowButton) {
        return;
      }
      const row = rowRef.current;
      if (!row || typeof IntersectionObserver === "undefined") {
        setShouldLoadFollowButton(true);
        return;
      }
      const observer = new IntersectionObserver(t7 => {
        const [entry] = t7;
        if (!entry?.isIntersecting) {
          return;
        }
        setShouldLoadFollowButton(true);
        observer.disconnect();
      }, {
        rootMargin: FOLLOW_STATUS_PREFETCH_MARGIN
      });
      observer.observe(row);
      return () => observer.disconnect();
    };
    t6 = [shouldShowFollowButton, shouldLoadFollowButton];
    $[4] = shouldLoadFollowButton;
    $[5] = shouldShowFollowButton;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  useEffect(t5, t6);
  const t7 = `${backgroundClass} tw-py-3`;
  let t8;
  if ($[8] !== follower.identity.handle || $[9] !== follower.identity.pfp) {
    t8 = <div className="tw-relative tw-h-10 tw-w-10 tw-flex-shrink-0 tw-rounded-lg tw-bg-iron-800"><div className="tw-h-full tw-w-full tw-rounded-lg"><div className="tw-h-full tw-w-full tw-max-w-full tw-overflow-hidden tw-rounded-lg tw-bg-iron-800 tw-ring-1 tw-ring-inset tw-ring-white/5"><div className="tw-flex tw-h-full tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-lg tw-text-center">{follower.identity.pfp ? <img src={follower.identity.pfp} alt={`${follower.identity.handle}'s profile`} className="tw-mx-auto tw-h-auto tw-max-h-full tw-w-auto tw-max-w-full tw-bg-transparent tw-object-contain" /> : <div className="tw-mx-auto tw-h-auto tw-max-h-full tw-w-auto tw-max-w-full tw-bg-transparent tw-object-contain" />}</div></div></div></div>;
    $[8] = follower.identity.handle;
    $[9] = follower.identity.pfp;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = `/${follower.identity.handle}`;
  let t10;
  if ($[11] !== follower.identity.handle || $[12] !== t9) {
    t10 = <p className="tw-mb-0 tw-min-w-0 tw-text-md tw-font-semibold tw-leading-none tw-text-iron-50"><Link href={t9} className="tw-block tw-truncate tw-no-underline tw-transition tw-duration-300 tw-ease-out hover:tw-text-iron-500 hover:tw-underline">{follower.identity.handle}</Link></p>;
    $[11] = follower.identity.handle;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== follower.identity.level) {
    t11 = <UserCICAndLevel level={follower.identity.level} size={UserCICAndLevelSize.SMALL} />;
    $[14] = follower.identity.level;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t10 || $[17] !== t11) {
    t12 = <div className="tw-flex tw-min-w-0 tw-flex-col"><div className="tw-flex tw-items-center tw-gap-x-1"><div className="tw-flex tw-min-w-0 tw-items-center tw-gap-x-2">{t10}{t11}</div></div></div>;
    $[16] = t10;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t12 || $[20] !== t8) {
    t13 = <div className="tw-flex tw-min-w-0 tw-items-center tw-gap-x-3">{t8}{t12}</div>;
    $[19] = t12;
    $[20] = t8;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== followerHandle || $[23] !== shouldLoadFollowButton || $[24] !== shouldShowFollowButton) {
    t14 = shouldShowFollowButton && followerHandle && <div className="tw-flex-shrink-0">{shouldLoadFollowButton ? <UserFollowBtn handle={followerHandle} size={UserFollowBtnSize.SMALL} /> : <div className="tw-h-8 tw-w-[7.25rem]" />}</div>;
    $[22] = followerHandle;
    $[23] = shouldLoadFollowButton;
    $[24] = shouldShowFollowButton;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t13 || $[27] !== t14) {
    t15 = <div className="tw-flex tw-items-center tw-justify-between tw-gap-x-3 tw-px-4 sm:tw-px-6">{t13}{t14}</div>;
    $[26] = t13;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t15 || $[30] !== t7) {
    t16 = <div ref={rowRef} className={t7}>{t15}</div>;
    $[29] = t15;
    $[30] = t7;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  return t16;
}